import React, { useEffect, useState, useContext } from 'react'
import ValidationWrapper from './validatingData'
import { DashboardContext } from 'live/context/dashboard'
import { defaultState } from './utils/utils'

const checkSectionsNames = (sectionsInput: Array<InputSectionTypes>): Array<OutputSectionTypes> => {
    const res: Array<OutputSectionTypes> = []

    if (Array.isArray(sectionsInput)) {
        sectionsInput.forEach(section => {
            if ((section.md_casing_shoe || section.endDepth) && (section.bit_diameter || section.innerDiameter)) {
                const sectionOutput: OutputSectionTypes = {
                    md_casing_shoe: section.md_casing_shoe ?? section.endDepth,
                    bit_diameter: section.bit_diameter ?? section.innerDiameter
                }
                if (section.casing_begin || section.startDepth) {
                    sectionOutput.casing_begin = section.casing_begin ?? section.startDepth
                }
                if (section.uom) sectionOutput.uom = section.uom
                if (section.name) sectionOutput.name = section.name
                if (section.open_hole) sectionOutput.open_hole = section.open_hole
                res.push(sectionOutput)
            }
        })
    }
    return res
}

export default function WellSchematicWidget(
    props: LiveReactChartProps<ChartStateWellSchematic, ChartMessageWellSchematic, Configs>
): JSX.Element {
    const { state } = useContext(DashboardContext)
    const [casingShoe, setCasingShoe] = useState(defaultState.casingShoe)
    const [drillstringVelocity, setDrillstringVelocity] = useState(defaultState.drillStringVelocity)
    const [holeDepth, setHoleDepth] = useState(defaultState.holeDepth)
    const [bitDepth, setBitDepth] = useState(defaultState.bitDepth)
    const [prevBitDepth, setPrevBitDepth] = useState(defaultState.prevBitDepth)
    const [uom, setUom] = useState(defaultState.uom)
    const [uomVelocity, setUomVelocity] = useState(defaultState.uomVelocity)
    const [sections, setSections] = useState(defaultState.sections)
    const [lithology, setLithology] = useState(defaultState.lithology)
    const [schematicType, setSchematicType] = useState(defaultState.schematicType)
    const [range, setRange] = useState(defaultState.range)
    const [canRender, setCanRender] = useState(defaultState.canRender)
    const [allowZoom, setAllowZoom] = useState(defaultState.allowZoom)
    const [heightOfOGMCartesian, setHeightOfOGMCartesian] = useState(defaultState.heightOfOGMCartesian)
    const [showDrillBit, setShowDrillBit] = useState(defaultState.showDrillBit)
    const [hideHoleDepth, setHideHoleDepth] = useState(defaultState.hideHoleDepth)
    const [paddingTop, setPaddingTop] = useState(defaultState.paddingTop)
    const [paddingBottom, setPaddingBottom] = useState(defaultState.paddingBottom)
    const [bottomComponent, setBottomComponent] = useState(defaultState.bottomComponent)

    useEffect(() => {
        setCasingShoe(defaultState.casingShoe)
        setDrillstringVelocity(defaultState.drillStringVelocity)
        setHoleDepth(defaultState.holeDepth)
        setBitDepth(defaultState.bitDepth)
        setPrevBitDepth(defaultState.prevBitDepth)
        setUom(defaultState.uom)
        setUomVelocity(defaultState.uomVelocity)
        setSections(defaultState.sections)
        setLithology(defaultState.lithology)
        setSchematicType(defaultState.schematicType)
        setRange(defaultState.range)
        setCanRender(defaultState.canRender)
        setHeightOfOGMCartesian(defaultState.heightOfOGMCartesian)
        setAllowZoom(defaultState.allowZoom)
        setShowDrillBit(defaultState.showDrillBit)
        setHideHoleDepth(defaultState.hideHoleDepth)
        setPaddingTop(defaultState.paddingTop)
        setPaddingBottom(defaultState.paddingBottom)
        setBottomComponent(defaultState.bottomComponent)
    }, [JSON.stringify(state?.currentFilterValues)])

    useEffect(() => {
        if (props.state?.value && typeof props.state.value === 'object' && Object.keys(props.state?.value).length > 1) {
            Object.keys(props.state.value).map(key => {
                switch (key) {
                    case 'casingShoe':
                        setCasingShoe(props.state.value[key])
                        break
                    case 'drillstringVelocity':
                        setDrillstringVelocity(props.state.value[key])
                        break
                    case 'bitDepth':
                        setBitDepth(props.state.value[key])
                        break
                    case 'prevBitDepth':
                        setPrevBitDepth(props.state.value[key])
                        break
                    case 'uom':
                        setUom(props.state.value[key])
                        break
                    case 'holeDepth':
                        setHoleDepth(props.state.value[key])
                        break
                    case 'uomVelocity':
                        setUomVelocity(props.state.value[key])
                        break
                    case 'schematicType':
                        setSchematicType(props.state.value[key])
                        break
                    case 'sections':
                        setSections(checkSectionsNames(props.state.value[key]))
                        break
                    case 'range':
                        setRange(props.state.value[key])
                        break
                    case 'heightOfOGMCartesian':
                        setHeightOfOGMCartesian(props.state.value[key])
                        break
                    case 'showDrillBit':
                        setShowDrillBit(props.state.value[key])
                        break
                    case 'bottomComponent':
                        setBottomComponent(props.state.value[key])
                        break
                    case 'hideHoleDepth':
                        setHideHoleDepth(props.state.value[key])
                        break
                    case 'paddingTop':
                        setPaddingTop(props.state.value[key])
                        break
                    case 'paddingBottom':
                        setPaddingBottom(props.state.value[key])
                        break
                    default:
                }
            })
            setCanRender(true)
        }

        if (
            props.state?.lithology &&
            typeof props.state.lithology === 'object' &&
            Object.keys(props.state?.lithology).length > 1
        ) {
            setLithology(props.state.lithology)
        }
    }, [JSON.stringify(props.state?.value)])

    useEffect(() => {
        if (
            props.state?.value &&
            typeof props.state.value === 'object' &&
            Object.keys(props.state?.value).length > 1 &&
            schematicType === 'holecleaning' &&
            range.length > 0 &&
            props.state.value.allowZoom
        ) {
            setAllowZoom(props.state.value.allowZoom)
        }
    }, [JSON.stringify(props.state?.value), schematicType, JSON.stringify(range)])

    return canRender ? (
        <ValidationWrapper
            casingShoe={casingShoe}
            holeDepth={holeDepth}
            drillstringVelocity={drillstringVelocity}
            bitDepth={bitDepth}
            prevBitDepth={prevBitDepth}
            uom={uom}
            uomVelocity={uomVelocity}
            lithology={lithology}
            schematicType={schematicType}
            sections={sections}
            heightOfOGMCartesian={heightOfOGMCartesian}
            range={range}
            allowZoom={allowZoom}
            showDrillBit={showDrillBit}
            hideHoleDepth={hideHoleDepth}
            paddingTop={paddingTop}
            paddingBottom={paddingBottom}
            width={props?.width ?? 220}
            height={(props?.height ?? 680) - paddingTop - paddingBottom}
            bottomComponent={bottomComponent}
        />
    ) : null
}
